import { Get, Post, Delete } from "../../utils/http-utils";
export const getDependencies = async () => {
  return Get("/scm/thing-group")
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return [];
    });
};

export const getTargets = async (queryParams = {}) => {
    return Get("/scm/thing", queryParams)
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return [];
        });
};



export const getDepFilters = async () => {
  return Get("/scm/thing-group/filters")
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return [];
    });
};


export const CreateDependency = async (jsonPayload) => {
    return Post("/scm/thing-group", jsonPayload)
        .then((data) => {
            return data;
        })
        .catch((err) => {
            throw err;
        });

}

export const deleteDependency = async (jsonPayload) => {
  return Delete("/scm/thing-group", jsonPayload)
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });
}